import { makeStyles } from '@material-ui/core/styles';
import { farmInterestedPartyStyles } from '../farm/additional-party/farm-interested-party.styles';

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    border: `2px solid ${theme.colorPalette.white}`,
    backgroundColor: theme.colors.page__background_primary,
    padding: '18px 32px 24px 32px',
    marginBottom: theme.spacing(2)
  },
  attestContainer: {
    gap: theme.spacing(3)
  },
  'light-textFieldRoot': {
    marginBottom: 10
  },
  button: {
    width: 163
  },
  formContainer: {
    marginTop: 0,
    marginBottom: 0
  },
  addButton: {
    marginTop: theme.spacing(4),
    width: '100%'
  },
  submitButton: {
    width: 163,
    marginTop: theme.spacing(2)
  },
  buttonRow: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end'
  },
  error: {
    color: theme.colors.error
  },
  address: {
    width: `calc(70% - ${theme.spacing(2)}px)`,
    marginRight: theme.spacing(2)
  },
  carToolTip: {
    marginRight: '10px'
  },
  trailerTip: {
    marginRight: -10
  },
  ...farmInterestedPartyStyles(theme),
  fo41Container: {
    ...farmInterestedPartyStyles(theme).fo41Container,
    padding: theme.spacing(2, 8, 2, 8)
  }
}));

export default useStyles;
